import axios from 'axios';

const requester = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
 
requester.interceptors.request.use(async (config) => {
  // const session = await getSession({ req })
  // if (token) {
  //   config.headers.Authorization = `Bearer ${token}`;
  // }
  return config;
});
// Add a response interceptor
requester.interceptors.response.use(
  function (response) {
    return Promise.resolve(response.data);
  },
  function (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // if (error.response?.status && ( error.response.status === 401 || error.response.status === 404)) {
      //   sessionStorage.removeItem('access_token');
      //   removeAxiosToken();
      // }
      error.status = error.response.status;
      error.message = error.response.statusText;
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      // console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      // console.log('Error', error.message);
    }
    return Promise.reject(error);
  }
);

export function setAxiosToken(clientId: string) {
  // requester.defaults.headers.common.clientId = clientId;
}

export function removeAxiosToken() {
  // requester.defaults.headers.common.clientId = '';
}
export default requester;
